import "@/index.css";
import "@/App.css";
import "@/lib/auth";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';

// Pages
import HomePage from "@/pages/HomePage";
import ServiziPage from "@/pages/ServiziPage";
import LavoraConNoiPage from "@/pages/LavoraConNoiPage";
import ChiSiamoPage from "@/pages/ChiSiamoPage";
import ContattiPage from "@/pages/ContattiPage";
import ApplicationPage from "@/pages/ApplicationPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import JobOffersPage from "@/pages/JobOffersPage";
import SubcontractRequestsPage from "@/pages/SubcontractRequestsPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servizi" element={<ServiziPage />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoiPage />} />
          <Route path="/lavora-con-noi/:type" element={<ApplicationPage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="/offerte-lavoro" element={<JobOffersPage />} />
          <Route path="/offerte-lavoro/:offerId" element={<JobOffersPage />} />
          <Route path="/richieste-subappalto" element={<SubcontractRequestsPage />} />
          <Route path="/richieste-subappalto/:requestId" element={<SubcontractRequestsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          style: {
            fontFamily: 'Open Sans, sans-serif'
          }
        }}
      />
    </div>
  );
}

export default App;
